import { CommonModule, CurrencyPipe, DecimalPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { IProductItem } from '@core/models/interfaces/product/product-item.interface';
import { GeneralInformationService } from '@services/assets-S3/general-information.service';
import { TextHelperService } from '@services/helpers/text-helper.service';

export type FormattedProduct = {
  numeroSusep: string;
  valorUnitario: string | null;
  percentualCapitalizacao: string;
  percentualSorteio: string;
};

@Component({
  selector: 'app-tp-legal-terms-text',
  standalone: true,
  imports: [CommonModule, RouterModule, CurrencyPipe, DecimalPipe],
  templateUrl: './tp-legal-terms-text.component.html',
  styleUrl: './tp-legal-terms-text.component.scss',
})
export class TpLegalTermsTextComponent {
  @Input({ required: true }) id!: string;
  @Input({ required: true }) set currentProduct(value: IProductItem) {
    if (value) {
      this.getLegalText(value);
    }
  }
  @Input() isEndNote = false;

  legalText!: SafeHtml;

  constructor(
    private generalInformationService: GeneralInformationService,
    private textHelper: TextHelperService,
    private currencyPipe: CurrencyPipe,
    private decimalPipe: DecimalPipe
  ) {}

  getLegalText(product: IProductItem) {
    const formattedProduct = {
      numeroSusep: product.susepNumber,
      valorUnitario: this.currencyPipe.transform(product.value || 0),
      percentualCapitalizacao: `${this.decimalPipe.transform(
        product.capPercentage || 0
      )}`,
      percentualSorteio: `${this.decimalPipe.transform(
        product.rafflePercentage || 0
      )}`,
    };

    this.generalInformationService.getLegalTermsText().subscribe(response => {
      this.legalText = this.textHelper.trustHtml(response, formattedProduct);
    });
  }
}
